const skuSubDirectory = "/sku";

export const getSkuCategories = `${skuSubDirectory}/getSkuCategories`;

export const getSkuSubCategories = `${skuSubDirectory}/:categoryId/getActiveSkuSubCategories`;

export const getAllSkuBrandsGivenSkuCategoryId = `${skuSubDirectory}/getAllSkuBrands`;

export const getAllSkus = `${skuSubDirectory}/getAllSkusForSalesWebsite`;

export const getSkuDetails = `${skuSubDirectory}/:skuId/getSkuDetailsForWebsite`;

export const checkSkusMatchingCar = `${skuSubDirectory}/checkSkusMatchingCar`;

export const GET_SKU_NAMES = `${skuSubDirectory}/getSkuNames`;

export const getAllMarketplaceSupplierPricesForSku = `${skuSubDirectory}/getAllMarketplaceSupplierPricesForSku`;

export const MATCH_SKU_PRICE_TIERING = `${skuSubDirectory}/matchSkuPriceTiering/:skuId`;

export const requestQuantityForExistingSku = `${skuSubDirectory}/requestQuantityForExistingSku`;

export const requestNewSku = `${skuSubDirectory}/requestNewSku`;

export const getSkuDetailsForRequestedSkus = `${skuSubDirectory}/getSkuDetailsForRequestedSkus`;

export const getSkuBrands = `${skuSubDirectory}/getSkuBrands`;

export const getAllSkuOriginList = `${skuSubDirectory}/getAllSkuOriginList`;

export const createSkuRepricingRequest = `${skuSubDirectory}/createSkuRepricingRequest`;

export const getSubstituteSkuList = `${skuSubDirectory}/getSubstituteSkuList/:skuId/:mechanicId`;

export const getRelevantSkuList = `${skuSubDirectory}/getRelevantSkuList/:skuId/:mechanicId`;

export const exportPriceListsAsPdf = `${skuSubDirectory}/exportPriceListsAsPdf`;

export const getAllSkuSubCategoriesNotPaginated = `${skuSubDirectory}/getAllSkuSubCategoriesNotPaginated`;

export const getPriceListSkuNames = `${skuSubDirectory}/getAllSkuNames`;
